const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNfc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M375.199 504.5H136.801c-17.853 0-32.325-14.472-32.325-32.325V39.825c0-17.853 14.472-32.325 32.325-32.325h238.398c17.853 0 32.325 14.472 32.325 32.325v432.35c0 17.853-14.472 32.325-32.325 32.325z",
    style: {},
    fill: "#d8ecfe",
    "data-original": "#d8ecfe",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.199 7.5h-28.285c17.853 0 32.325 14.473 32.325 32.325v432.35c0 17.853-14.473 32.325-32.325 32.325h28.285c17.853 0 32.325-14.473 32.325-32.325V39.825c0-17.852-14.472-32.325-32.325-32.325z",
    style: {},
    fill: "#64b5f6",
    "data-original": "#c4e2ff",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.687 439.849H88.313c-8.926 0-16.163-7.236-16.163-16.163V221.654c0-8.926 7.236-16.163 16.163-16.163h335.374c8.926 0 16.163 7.236 16.163 16.163v202.033c0 8.926-7.237 16.162-16.163 16.162z",
    style: {},
    fill: "#ffb74d",
    "data-original": "#8ac9fe",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.687 205.492h-28.285c8.926 0 16.163 7.236 16.163 16.163v202.033c0 8.926-7.236 16.163-16.163 16.163h28.285c8.926 0 16.163-7.236 16.163-16.163V221.654c0-8.926-7.237-16.162-16.163-16.162z",
    style: {},
    fill: "#ffa726",
    "data-original": "#60b7ff",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15 375.199h367.699v32.325H72.15z",
    style: {},
    fill: "#918291",
    "data-original": "#918291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.565 375.199h28.285v32.325h-28.285z",
    style: {},
    fill: "#7a6d79",
    "data-original": "#7a6d79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.52 205.49v-65.28M104.48 122.66V39.83c0-17.85 14.47-32.33 32.32-32.33h238.4c17.85 0 32.32 14.48 32.32 32.33v65.28M104.48 205.49v-47.73M407.524 439.85v32.325c0 17.85-14.476 32.325-32.325 32.325H136.801c-17.85 0-32.325-14.476-32.325-32.325V439.85M245.898 39.825h20.204M245.898 472.175h20.204M298.427 39.825h0M213.573 39.825h0M172.93 317.62v-54.447l38.224 54.447v-54.549M265.588 263.071h-22.109v54.549M243.479 289.829h20.353M337.137 267.729a27.147 27.147 0 0 0-15.249-4.658c-15.063 0-27.274 12.211-27.274 27.274s12.211 27.274 27.274 27.274c6.118 0 11.15-2.014 14.969-5.416a22.027 22.027 0 0 0 2.214-2.284M72.15 375.199h367.7M312.11 407.52H72.15M439.85 407.52h-92.68",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.687 439.849H88.313c-8.926 0-16.163-7.236-16.163-16.163V221.654c0-8.926 7.236-16.163 16.163-16.163h335.374c8.926 0 16.163 7.236 16.163 16.163v202.033c0 8.926-7.237 16.162-16.163 16.162zM196.171 113.274c32.99-32.99 86.669-32.99 119.659 0M217.927 135.03c20.994-20.994 55.153-20.994 76.147 0M239.683 156.786c9.012-9.012 23.623-9.012 32.634 0",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfc);
export default __webpack_public_path__ + "static/media/nfc.0dbab7a7ee023c242c5b0dd35f7d8493.svg";
export { ForwardRef as ReactComponent };